function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import useHasPermission from '../../helpers/hooks/useHasPermission';
import ModalHeader from '../modal/ModalHeader.react';
var _Button = function Button(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'primary' : _ref$type,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _onClick = _ref.onClick,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$apiID = _ref.apiID,
    apiID = _ref$apiID === void 0 ? false : _ref$apiID,
    _ref$requireConfirmat = _ref.requireConfirmation,
    requireConfirmation = _ref$requireConfirmat === void 0 ? false : _ref$requireConfirmat,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? null : _ref$icon,
    _ref$permission = _ref.permission,
    permission = _ref$permission === void 0 ? null : _ref$permission;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showConfirmation = _useState2[0],
    setShowConfirmation = _useState2[1];
  var activeApiCalls = useSelector(function (s) {
    return s.app.activeApiCalls;
  });
  var hasPermission = useHasPermission(permission);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var isDisabled = function isDisabled() {
    return disabled || loading || (activeApiCalls === null || activeApiCalls === void 0 ? void 0 : activeApiCalls.find(function (x) {
      return x.id === apiID;
    })) || false;
  };

  // const isLoading = () => apiID && activeApiCalls?.find(x => x.id === apiID);

  useEffect(function () {
    setIsLoading(loading || (activeApiCalls === null || activeApiCalls === void 0 ? void 0 : activeApiCalls.find(function (x) {
      return x.id === apiID;
    })));
  }, [loading, apiID, activeApiCalls]);
  if (!hasPermission) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: ['btn', "btn__".concat(type), "".concat(className), "".concat(isDisabled() ? 'btn__disabled' : '')].join(' '),
    style: style,
    disabled: disabled,
    onClick: function onClick() {
      if (isDisabled()) return;
      if (requireConfirmation) setShowConfirmation(true);else if (_onClick) _onClick();
    }
  }, label || children, icon && /*#__PURE__*/React.createElement("img", {
    src: "/public/images/icons/".concat(icon),
    className: "btn__icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "btn__overlay"
  }), isLoading && /*#__PURE__*/React.createElement("div", {
    className: "btn__loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn__loader--spinner"
  }))), showConfirmation && /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("div", {
    className: "modal confirmation-modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Are You Sure?",
    onClose: function onClose() {
      return setShowConfirmation(false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body confirmation-modal__body"
  }, /*#__PURE__*/React.createElement(_Button, {
    label: "No!",
    type: "cancel",
    onClick: function onClick() {
      return setShowConfirmation(false);
    }
  }), /*#__PURE__*/React.createElement(_Button, {
    label: "Yes!",
    onClick: function onClick() {
      setShowConfirmation(false);
      if (_onClick) _onClick();
    }
  }))), document.getElementById('root')));
};
export default _Button;